"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPointerPosOnVisibleArea = void 0;
/**
 * @description
 * マウスポインタのキャンバス上の位置を画像上の位置に変換する．
 */
var toPointerPosOnVisibleArea = 
// dummy comment to control prettier
function (imgVisibleAreaRectAbsolute) {
    // dummy comment to control prettier
    return function (pointerPos) {
        return pointerPos.withMutations(function (from) {
            return from
                .update('x', function (x) { return x - imgVisibleAreaRectAbsolute.left; })
                .update('y', function (y) { return y - imgVisibleAreaRectAbsolute.top; });
        });
    };
};
exports.toPointerPosOnVisibleArea = toPointerPosOnVisibleArea;
